import { get, http } from './request'

export default {
    loadReport: (payload, success, failure) =>
        get(payload.path, success, failure, { params: payload.params }),

    downloadCsv: (filters, success, failure) =>
        http({
            method: 'get',
            url: '/api/asset-transfers/report/download',
            params: filters,
            responseType: 'blob',
        }).then(response => success(response)).catch(error => failure(error)),
}
